<!-- =========================================================================================
  File Name: DataViewSidebar.vue
  Description: Add New Data - Sidebar component
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
        <h4>{{ Object.entries(this.data).length === 0 ? "ADD NEW" : "EDIT" }} INSTANT MESSAGE</h4>
        <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <component :is="scrollbarTag" class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">

      <div class="p-6">
        <label class="vs-select--label w-full">Message *</label>
        <vs-textarea label="" v-model="dataMessage" name="message" v-validate="'required'"/>
        <div v-for="(PhoneNumber, index) in SmsNumber" :key="index">
        <span class="flex">
        <vs-input placeholder="Enter Phone" v-model="PhoneNumber.phone" @input="acceptNumber(PhoneNumber.phone,index)" class="w-full" />
        <span   class="text-danger mt-2 ml-2 font-bold" style="cursor: pointer"  @click="removeNumber(index)">x</span>
        </span>
         <span  v-if="PhoneNumber.phone.length > 0 &&  PhoneNumber.phone.length < 14" class="text-danger text-sm">Invalid phone number format.</span>
        </div>
        <vs-button color="primary" size="small" @click.native="addNewNumber()" style="float:right" class="mr-3 mt-2">
         <feather-icon icon="PlusIcon" svgClasses="h-2 w-2"/>
         </vs-button>

 
      </div>
    </component>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6 vs-con-loading__container" ref="loadableButton" id="button-with-loading"  @click="submitData" :disabled="!isFormValid">{{$t('student.add.btn_submit')}}</vs-button>
      <vs-button type="border" color="danger" @click.native="isSidebarActiveLocal = false">{{$t('student.add.btn_cancel')}}</vs-button>
    </div>
  </vs-sidebar>
</template>


<script>
import Datepicker from 'vuejs-datepicker'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import vSelect from 'vue-select'
import moment from 'moment'
import {CREATE_INSTANT_SMS

} from '@/graphql'
export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    VuePerfectScrollbar,
    'v-select': vSelect,
    Datepicker,
    moment
  },
  data () {
    return {
      dataId:null,
      dataMessage:'',
      SmsNumber:[
        {
          phone :''
        }
      ],
      settings: { // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: .60
      },
      btnDisable:true
    }
  },
  watch: {
    isSidebarActive (val) {
      if (!val) return
      if (Object.entries(this.data).length === 0) {
        this.initValues()
        this.$validator.reset()
      } else {
        const {id} = JSON.parse(JSON.stringify(this.data))
        this.dataId = id
      }
    }
  },
  computed: {
    isSidebarActiveLocal: {
      get () {
        return this.isSidebarActive
      },
      set (val) {
        if (!val) {
          this.$emit('closeSidebar')
          this.$validator.reset()
          this.initValues()
        }
      }
    },
    isFormValid () {
      return !this.errors.any() && this.dataMessage && this.btnDisable
    },
    scrollbarTag () { return this.$store.getters.scrollbarTag }
  },
  methods: {
    addNewNumber () {
      this.SmsNumber.push(
        {
          phone:''
        }
      )
    },
    removeNumber (index) {
      this.SmsNumber.splice(index, 1)
    },
    acceptNumber (phone, index) {
      const x = phone
        .replace(/\D/g, '')
        .match(/(\d{0,3})(\d{0,3})(\d{0,4})/)

      this.SmsNumber[index].phone = !x[2]
        ? x[1]
        : `(${  x[1]  }) ${  x[2]  }${x[3] ? `-${  x[3]}` : ''}`
    },
    StatusSuccess (msg) {
      this.$vs.notify({
        title: 'Instant Message',
        text:  msg,
        color: 'success',
        position: 'top-right'
      })
    },
    initValues () {
      this.dataMessage = ''
      this.SmsNumber = [
        {
          phone :''
        }
      ]
      this.btnDisable = true
    },
    openLoadingContained () {
      this.$vs.loading({
        background: this.backgroundLoading,
        color: this.colorLoading,
        container: this.$refs.loadableButton.$el,
        scale: 0.45
      })
    },
    submitData () {
      const numbers = []
      if (this.SmsNumber.length > 0) {
        for (let index = 0; index < this.SmsNumber.length; index++) {
          console.log(this.SmsNumber[index].phone)
          if (this.SmsNumber[index].phone.length === 14) {
            numbers.push(this.SmsNumber[index].phone)
          } else {
            this.$vs.notify({
              title: 'Error',
              text:  `Enter a valid number at phone ${index + 1}`,
              color: 'danger',
              position: 'top-right' 
            })
            return 
          }
          
        }
      } else {
        this.$vs.notify({
          title: 'Error',
          text:  'Add Phone to send message',
          color: 'danger',
          position: 'top-right' 
        })
        return 
      }
      this.btnDisable = false
      this.openLoadingContained()
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.dataId !== null && this.dataId >= 0) {
            this.$apollo
              .mutate({
                mutation: UPDATE_ANNOUNCEMENT,
                variables: {
                  id :this.dataId,
                  msg: this.dataMessage,
                  status:this.dataStatus,
                  locations,
                  roles
                }
              })
              .then(response => {
                if (response) {
                  this.StatusSuccess(response.data.updateAnnouncement.message, response.data.updateAnnouncement.color)
                  if (response.data.updateAnnouncement.status == 'Success') {
                    this.$vs.loading.close(this.$refs.loadableButton.$el)
                    this.btnDisable = true
                    this.$emit('closeSidebar')
                    this.initValues()
                    this.$emit('getdata', true)
                  }

                }
              }).catch(error => {
                this.$vs.loading.close(this.$refs.loadableButton.$el)
                this.btnDisable = true
              })

          } else {
            this.$apollo
              .mutate({
                mutation: CREATE_INSTANT_SMS,
                variables: {
                  msg: this.dataMessage,
                  phones:numbers
                }
              })
              .then(response => {
                if (response) {
                  this.$vs.loading.close(this.$refs.loadableButton.$el)
                  this.btnDisable = true
                  if (response.data.createInstantSms.status === 'Success') {
                    this.StatusSuccess(response.data.createInstantSms.message)
                    this.$emit('closeSidebar')
                    this.initValues()
                    this.$emit('getdata', true)
                  }
                }
              }).catch(error => {
                this.$vs.loading.close(this.$refs.loadableButton.$el)
                this.btnDisable = true
              })
          }
        }
      })
    }
  },
  created () {

  }
}
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
    // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
    height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

    &:not(.ps) {
      overflow-y: auto;
    }

}
</style>
